import { Component } from '@angular/core';
import { ThirdPartyReferenceType } from '@lsq-frontend/remote-services/enterprise/common';
import { ProspectData, StageData } from '@lsq-frontend/remote-services/ar-app';
import { DrApplicationService } from '@lsqlabs/dr-application-shared';
import { DashboardExperience } from './../../../../../constants/experience.constants';
import {
    CompanyDetail,
    GetCompanyDetailService,
    GetCompanyRequest,
    ThirdPartyReference
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@Component({
    selector: 'prospect-users',
    styleUrls: ['./prospect-users.component.scss'],
    templateUrl: './prospect-users.component.html'
})
export class ManageProspectUsersComponent {
    public prospect: ProspectData = { ...this.arService.getProspect() };
    public prospectCompanyKey: string;
    public clientDashboardExperiences: DashboardExperience[] = [];
    public noCompanyMessage: string;

    constructor(
        private arService: DrApplicationService,
        private _companyDetailService: GetCompanyDetailService
    ) {}

    public async ngOnInit(): Promise<void> {
        if (!!this.prospect?.companyKey) {
            this.prospectCompanyKey = this.prospect.companyKey;
            const getCompanyRequestParams = new GetCompanyRequest({
                companyKey: this.prospectCompanyKey
            });
            const companyDetail = (
                await this._companyDetailService.executeOnce(getCompanyRequestParams)
            ).companyDetail as CompanyDetail;
            this.clientDashboardExperiences = this._getClientExperiences(companyDetail);
        } else {
            const invitedProspectUser = this.getUserFromProspect(this.prospect);
            this.noCompanyMessage =
                'Invited prospect must create an account.\nThe user ' +
                invitedProspectUser +
                ' must submit the first step of the sent invitation.';
        }
    }

    private getUserFromProspect(prospect: ProspectData) {
        var stages = prospect?.stages;
        if (!!!stages) {
            return '';
        }
        var accountStage: StageData = stages['stage-schema-create-account'];
        var emailField = accountStage?.fields['field-schema-email'];
        return emailField?.fieldValue || '';
    }

    private _getClientExperiences(company: CompanyDetail): DashboardExperience[] {
        const experiences = [];
        if (
            company.thirdPartyReferences.some(
                (thirdPartyReference: ThirdPartyReference) =>
                    thirdPartyReference.thirdPartyReferenceType ===
                    ThirdPartyReferenceType.Factorsoft
            )
        ) {
            experiences.push(DashboardExperience.Factoring);
        }
        if (
            company.thirdPartyReferences.some(
                (thirdPartyReference: ThirdPartyReference) =>
                    thirdPartyReference.thirdPartyReferenceType ===
                    ThirdPartyReferenceType.FinancingSeller
            )
        ) {
            experiences.push(DashboardExperience.SCF_Seller);
        }
        if (
            company.thirdPartyReferences.some(
                (thirdPartyReference: ThirdPartyReference) =>
                    thirdPartyReference.thirdPartyReferenceType ===
                    ThirdPartyReferenceType.FinancingBuyer
            )
        ) {
            experiences.push(DashboardExperience.SCF_Buyer);
        }
        if (
            company.thirdPartyReferences.some(
                (thirdPartyReference: ThirdPartyReference) =>
                    thirdPartyReference.thirdPartyReferenceType ===
                    ThirdPartyReferenceType.FinancingAccount
            )
        ) {
            experiences.push(DashboardExperience.SCF_Account);
        }
        return experiences;
    }
}
